import React from "react";
import {Cloud, Fog, Rain, Snow, Storm, Sun} from "./gausta/weatherIcons";

import en from "./gausta/translations/en"
import no from "./gausta/translations/no"
import sv from "./gausta/translations/sv"

class GaustaWeatherService {
    storage: any = undefined;

    async fetch() {
        if (this.storage) return this.storage;
        const weather_data = await fetch("https://api.fnugg.no/get/resort/14")
            .then((response) => response.json())
            .then((data) => { return data._source; })
        this.storage = weather_data;
    }

    fnugg() {
        return this.storage;
    }

    getTopmenuWeatherWidgetData() {
        const fnuggWeather = this.storage;
        return {
            temperature: fnuggWeather?.conditions?.combined?.top?.temperature?.value || "-",
            status: fnuggWeather?.conditions?.combined?.top?.symbol?.yr_id || "0",
            icon: fnuggWeather?.conditions.combined.top.symbol.yr_id || "-",
            windSpeed: fnuggWeather?.conditions?.current_report?.top?.wind?.speed|| "0",
        };
    }

    getWeatherIcon(id: number) {
        switch (id) {
            case 1:
            return <Sun />;
            case 2:
            case 3:
            case 4:
            return <Cloud />;
            case 8:
            case 13:
            case 44:
            case 45:
            case 49:
            case 50:
            return <Snow />;
            case 6:
            case 11:
            case 14:
            case 20:
            case 21:
            case 22:
            case 23:
            case 24:
            case 25:
            case 26:
            case 27:
            case 28:
            case 29:
            case 30:
            case 31:
            case 32:
            case 33:
            case 34:
            return <Storm />;
            case 5:
            case 7:
            case 9:
            case 10:
            case 12:
            case 40:
            case 41:
            case 42:
            case 43:
            case 46:
            case 47:
            case 48:
            return <Rain />;
            case 15:
            return <Fog />;
            default:
            return null;
        }
    }

    getWeatherStatusText(id: number) {
        switch (id) {
            case 1:
                return "Sunny";
            case 2:
            case 3:
            case 4:
                return "Cloudy";
            case 8:
            case 13:
            case 44:
            case 45:
            case 49:
            case 50:
                return "Snow";
            case 6:
            case 11:
            case 14:
            case 20:
            case 21:
            case 22:
            case 23:
            case 24:
            case 25:
            case 26:
            case 27:
            case 28:
            case 29:
            case 30:
            case 31:
            case 32:
            case 33:
            case 34:
                return "Storm";
            case 5:
            case 7:
            case 9:
            case 10:
            case 12:
            case 40:
            case 41:
            case 42:
            case 43:
            case 46:
            case 47:
            case 48:
                return "Rain";
            case 15:
                return "Foggy";
            default:
                return "";
        }
    }
}


class GaustaTranslationsService {
    
    current_locale = "no"

    en = en 
    no = no
    sv = sv

    translate(key: string, deftext?: string) {
      const translations = (this as unknown as any)[this.current_locale];
      return (translations && translations[key]) || deftext || key;
    }
}

class GaustaService {
    static weather = new GaustaWeatherService();
    static translations = new GaustaTranslationsService();
}

export default GaustaService;


